import { useAuthentication } from '@/contexts/dataSync/AuthenticationContext';
import { hasUserPermission, UserPermission } from '@shared/enums';
import { isInternalUser } from '@shared/utilities';

export const useCanWrite = () => {
  const { user } = useAuthentication();

  if (!user) {
    return false;
  }

  return (
    !isInternalUser(user)
    || hasUserPermission(user.permissions, UserPermission.InternalCanWrite)
  );
};
